/**
 * Our Blog Section - Swiper Slider Controller
 * Supports multi-instance scoping and Shopify Theme Customizer lifecycle hooks
 */

(function () {
  'use strict';

  function initOurBlogSliders(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.our-blog-section[data-slider-enabled="true"]');

    sections.forEach(function (section) {
      var sectionId = section.getAttribute('data-section-id');
      var sliderEl = section.querySelector('.our-blog-slider');
      if (!sliderEl) return;

      // Clean up previous instance if exists (e.g. on Shopify theme editor re-render)
      if (sliderEl.swiper && typeof sliderEl.swiper.destroy === 'function') {
        sliderEl.swiper.destroy(true, true);
      }

      var nextBtn = section.querySelector('.our-blog-nav-next');
      var prevBtn = section.querySelector('.our-blog-nav-prev');
      var paginationEl = section.querySelector('.our-blog-pagination');

      var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed') || '5', 10) * 1000;

      var swiperOptions = {
        slidesPerView: 1.15,
        spaceBetween: 16,
        grabCursor: true,
        watchSlidesProgress: true,
        speed: 550,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          540: {
            slidesPerView: 1.8,
            spaceBetween: 18,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 22,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 26,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      // Check if global Swiper is loaded
      if (typeof Swiper !== 'undefined') {
        new Swiper(sliderEl, swiperOptions);
      } else {
        // Fallback retry if script defer arrives slightly after
        var checkSwiper = setInterval(function () {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            new Swiper(sliderEl, swiperOptions);
          }
        }, 100);
        setTimeout(function () {
          clearInterval(checkSwiper);
        }, 4000);
      }
    });
  }

  // Initialize on document ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initOurBlogSliders();
    });
  } else {
    initOurBlogSliders();
  }

  // Support Shopify Theme Editor live updates
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('our-blog-section') || event.target.querySelector('.our-blog-section')) {
      initOurBlogSliders(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sliderEl = event.target.querySelector('.our-blog-slider');
    if (sliderEl && sliderEl.swiper && typeof sliderEl.swiper.destroy === 'function') {
      sliderEl.swiper.destroy(true, true);
    }
  });
})();
